import React from 'react';
import { useLocation } from '../../modules/location/LocationContext';

export default function LocationBanner() {
  // Since we're not detecting location anymore, just return null
  return null;
}